import { FunctionComponent } from 'react';

import ArticlesSearch from 'components/modules/public/layout/forms/SearchEmployeeArticlesForm';

import StyledComponent from './styles';
import { Props } from './types';

const PublicPageCategoryArticlesEmployeeSectionForm: FunctionComponent<Props> = ({ translations: { formProps }, articleCategories }) => {
    return (
        <StyledComponent
            className="public-page-category-articles-employee-section-form"
        >
            <ArticlesSearch
                {...formProps}
                categories={articleCategories}
            />
        </StyledComponent>
    );
};

export default PublicPageCategoryArticlesEmployeeSectionForm;